export type ACLID = number;

export enum ROLES {
  SuperAdmin = 10,
  ClaireAdmin = 20,
  SupportAdmin = 25,
  Consultant = 30,
  DealerAdmin = 40,
  ExactAdmin = 45,
  Receptionist = 50,
  ChiefMechanic = 55,
  Mechanic = 60,
  CallCenter = 70,
  Supervisor = 80,
  WarrantyManager = 90,
  CounterTablet = 100,
  Manufacturer = 110
}

export enum ACL_ACTIVITIES {
  Assist = "assist",
  Browse = "browse",
  Create = "create",
  Delete = "delete",
  Export = "export",
  Import = "import",
  List = "list",
  Process = "process",
  Reorder = "reorder",
  Search = "search",
  Update = "update"
}

export enum ACL_RESOURCES {
  AAEquipmentTyreScanner = "aaequipment-tyrescanner",
  AcsesAvailableLockers = "acses-available-lockers",
  AcsesDropBack = "acses-dropback",
  AcsesHistory = "acses-history",
  AcsesPickUp = "acses-pickup",
  Agreements = "agreements",
  AppointmentChecksReportURL = "appointment-checks-report-url",
  AppointmentCustomers = "appointment-customers",
  AppointmentHistory = "appointment-history",
  AppointmentNotes = "appointment-notes",
  AppointmentNotesAttachments = "appointment-notes-attachments",
  AppointmentNotesBills = "appointment-notes-bills",
  AppointmentNotesCustomerCall = "appointment-notes-customer-call",
  AppointmentNotesNoDrive = "appointment-notes-no-drive",
  AppointmentNotesParkingLocation = "appointment-notes-parking-location",
  AppointmentNotesRecurringCar = "appointment-notes-recurring-car",
  AppointmentNotesTempDriver = "appointment-notes-temp-driver",
  AppointmentNotesURLs = "appointment-notes-urls",
  AppointmentNotesWO = "appointment-notes-wo",
  Appointments = "appointments",
  AppointmentsBackOrder = "appointments-backorder",
  AppointmentsBilling = "appointments-billing",
  AppointmentsCancel = "appointments-cancel",
  AppointmentsCarInShop = "appointments-car-in-shop",
  AppointmentsCarOutOfShop = "appointments-car-out-of-shop",
  AppointmentsCarReady = "appointments-car-ready",
  AppointmentsContact = "appointments-contact",
  AppointmentsCustomerOk = "appointments-customer-ok",
  AppointmentsCustomerOwner = "appointments-customer-owner",
  AppointmentsCustomerWaiting = "appointments-customer-waiting",
  AppointmentsDates = "appointments-dates",
  AppointmentsInfo = "appointments-info",
  AppointmentsLogs = "appointments-logs",
  AppointmentsMakeAnOffer = "appointments-make-an-offer",
  AppointmentsMileages = "appointments-mileages",
  AppointmentsNewCar = "appointments-new-car",
  AppointmentsPinned = "appointments-pinned",
  AppointmentsPricingOk = "appointments-pricing-ok",
  AppointmentsShoppingCart = "appointments-shopping-cart",
  AppointmentsStar = "appointments-star",
  AppointmentStatuses = "appointment-statuses",
  AppointmentsThreeDepartments = "appointments-three-departments",
  AppointmentsThreeDepartmentsPage = "appointments-three-departments-page",
  AppointmentWONrCounter = "appointment-wonr-counter",
  Articles = "articles",
  ArticlesStripeCount = "articles-stripe-count",
  Backorders = "backorders",
  BrandGroups = "brand-groups",
  Brands = "brands",
  CarCheckQuestionResultRemark = "car-check-question-result-remark",
  CarCheckQuestionResults = "car-check-question-results",
  CarChecks = "car-checks",
  CarDetails = "car-details",
  CarNotes = "car-notes",
  CarNotesAttachments = "car-notes-attachments",
  CarRDW = "car-rdw",
  Cars = "cars",
  CarsAppointment = "cars-appointments",
  CarsByCustomer = "cars-by-customer",
  CarsByRegNr = "cars-by-regnr",
  CarTyres = "car-tyres",
  CheckInAgreement = "check-in-agreement",
  CheckInRemarks = "check-in-remarks",
  CheckInService = "check-in-service",
  CheckInServiceAccepted = "check-in-service-accepted",
  CheckInServicePendingChecklist = "check-in-service-pending-checklist",
  CheckInServiceRemarkHandled = "check-in-service-remark-handled",
  Checklists = "checklists",
  ChecklistTemplates = "checklist-templates",
  CommunicationSettings = "communication-settings",
  CommunicationSettingsLogo = "communication-settings-logo",
  CommunicationSettingsPictures = "communication-settings-pictures",
  CommunicationSettingsWelcomePicture = "communication-settings-welcome-picture",
  CustomcomRepairOverview = "customcom-repair-overview",
  CustomerNoteAttachments = "customer-note-attachments",
  CustomerNotes = "customer-notes",
  Customers = "customers",
  CustomerServiceDetails = "customer-service-details",
  DataOfficer = "data-officer",
  Dayplanner = "dayplanner",
  DayplannerAppointmentAssign = "dayplanner-appointment-assign",
  DayplannerMechanics = "dayplanner-mechanics",
  DBB = "dbb",
  DBBAppointmentDate = "dbb-appointment-date",
  DBBContract = "dbb-contract",
  DBBTyreLimits = "dbb-tyre-limits",
  DealerChecklistAttachment = "dealer-checklist-attachment",
  DealerDocumentation = "dealer-documentation",
  DealerDocumentationFiles = "dealer-documentation-files",
  DealerDomains = "dealer-domains",
  Dealers = "dealers",
  DealersReport = "dealers-report",
  DealersReportEmail = "dealers-report-email",
  DealersReportGroup = "dealers-report-group",
  DealersReportThreshold = "dealers-report-threshold",
  DefaultChecklists = "default-checklists",
  DeskCheckin = "desk-checkin",
  DeskCheckinCounterTablet = "desk-checkin-counter-tablet",
  DeskCheckinCounterTabletReceptionists = "desk-checkin-counter-tablet-receptionists",
  Devices = "devices",
  DevicesLease = "devices-lease",
  DiagnoseOverview = "diagnose-overview",
  DiagnoseOverviewRemarks = "diagnose-overview-remarks",
  DMSCapabilities = "dms-capabilities",
  DMSv3CustomQuery = "dmsv3-customquery",
  DMSv3MonitoringWarnings = "dmsv3-monitoring-warnings",
  DMSv3SettingDealers = "dmsv3-setting-dealers",
  DMSv3SettingLocation = "dmsv3-setting-location",
  DMSv3SettingPage = "dmsv3-setting-page",
  ExactAccounts = "exact-accounts",
  ExactInvoice = "exact-invoice",
  ExactLicense = "exact-license",
  ExactLicenseCategory = "exact-license-category",
  ExactMonitoring = "exact-monitoring",
  FactoryExport = "factory-export",
  FactoryExportReceivers = "factory-export-receivers",
  Files = "files",
  Holding = "holding",
  HoldingCarsAppointmentHistory = "holding-cars-appointment-history",
  IAM = "iam",
  IAMReInstate = "iam-reinstate",
  InterventionAttachments = "intervention-attachments",
  InterventionElements = "intervention-elements",
  InterventionElementsCodes = "intervention-elements-codes",
  InterventionKeywordPendingChecklist = "intervention-keywords-pending-checklist",
  InterventionPendingChecklist = "intervention-pending-checklist",
  Interventions = "interventions",
  Keylockers = "keylockers",
  KeylockersAdminPin = "keylockers-admin-pin",
  KeylockersBox = "keylockers-box",
  KeylockersDropBackScan = "keylockers-drop-back-scan",
  KeylockersPickupScan = "keylockers-pickup-scan",
  KeylockersRemarks = "keylockers-remarks",
  Kiosk = "kiosk",
  KioskLabels = "kiosk-labels",
  KioskRemark = "kiosk-remark",
  LeadsAdvisedCriticalHistory = "leads-advised-critical-history",
  LeadsCars = "leads-cars",
  LeadsNotSnoozed = "leads-not-snoozed",
  LeadsSnoozed = "leads-snoozed",
  LeadsTires = "leads-tires",
  LocationChecklistAttachment = "location-checklist-attachment",
  Locations = "locations",
  LocationsReport = "locations-report",
  LocationsReportGroup = "locations-report-group",
  Logos = "logos",
  ManufacturerRequest = "manufacturer-request",
  Mediums = "mediums",
  MobileVersions = "mobile-versions",
  NoteSuggestions = "note-suggestions",
  OnlineCheckIn = "online-checkin",
  ParkingGateCode = "parking-gate-code",
  Pin = "pin",
  PinFull = "pin-full",
  PinNote = "pin-note",
  PinPendingChecklist = "pin-pending-checklist",
  PinRemark = "pin-remark",
  PlanItAppointment = "planit-appointment",
  PONOCWCarMileageCapability = "pon-ocw-car-mileage-capability",
  PONOCWEnrollmentPortal = "pon-ocw-enrollment-portal",
  PONOCWServicePortal = "pon-ocw-service-portal",
  PONOCWVehicleStatus = "pon-ocw-vehicle-status",
  PONVehicleOilNorm = "pon-vehicle-oil-norm",
  PONVehicleOvis = "pon-vehicle-ovis",
  PublicAPI = "publicapi",
  PublicAPIAccount = "publicapi-account",
  PublicAPIKeys = "publicapi-keys",
  PublicAPILogs = "publicapi-logs",
  QuestionElements = "question-elements",
  Questions = "questions",
  Recalls = "recalls",
  ROBNetContract = "robnet-contract",
  ROBNetContractRegNr = "robnet-contract-regnr",
  ROBNetLessor = "robnet-lessor",
  ROBNetServiceRequests = "robnet-service-requests",
  ROBNetSLA = "robnet-sla",
  ReportTemplates = "report-templates",
  Settings = "settings",
  ShareboxCabinetAvailable = "sharebox-cabinet-available",
  ShareboxEmployeeAssistPickup = "sharebox-employee-assist-pickup",
  ShareboxEmployeeDropBack = "sharebox-employee-drop-back",
  ShareboxEmployeePickup = "sharebox-employee-pickup",
  ShareboxLogs = "sharebox-logs",
  Snooze = "snooze",
  ServiceBoxWOWidget = "servicebox-wo-widget",
  ServiceBoxCarWidget = "servicebox-car-widget",
  ServiceBoxTabletWidget = "servicebox-tablet-widget",
  ServiceBoxLocationWidget = "servicebox-location-widget",
  Tags = "tags",
  TranslationsMigration = "translations-migration",
  TwilioSubAccount = "twilio-sub-account",
  TwilioSubAccountApiKey = "twilio-sub-account-api-key",
  TwilioSubAccountDollarLimit = "twilio-sub-account-dollar-limit",
  TwilioSubAccountNumber = "twilio-sub-account-number",
  TwilioSubAccountNumberPricing = "twilio-sub-account-number-pricing",
  TwilioSubAccountSMSLimit = "twilio-sub-account-sms-limit",
  TyreMotionAIWheelData = "tyremotion-ai-wheel-data",
  TyreNet = "tyrenet",
  TyreNetOrder = "tyrenet-order",
  TyreNetStock = "tyrenet-stock",
  Tyres = "tyres",
  TyresBrand = "tyres-brand",
  TyresDimensions = "tyres-dimensions",
  TyresHeight = "tyres-height",
  TyresIncomplete = "tyres-incomplete",
  TyresIncompleteComplete = "tyres-incomplete-complete",
  TyresIncompleteReplace = "tyres-incomplete-replace",
  TyresReplacement = "tyres-replacement",
  TyresReplacementMount = "tyres-replacement-mount",
  TyresSize = "tyres-size",
  TyresSpeed = "tyres-speed",
  TyresStorageSet = "tyres-storage-set",
  TyresUpdate = "tyres-update",
  TyresWidth = "tyres-width",
  TyreTeamBrands = "tyreteam-brands",
  TyreTeamCatalog = "tyreteam-catalog",
  TyreTeamCatalogOrder = "tyreteam-catalog-order",
  TyreTeamCatalogStock = "tyreteam-catalog-stock",
  TyreTeamCredential = "tyreteam-credential",
  TyreTeamReplacement = "tyreteam-replacement",
  TyreDiscounts = "tyre-discounts",
  TyreDiscountCategories = "tyre-discount-categories",
  TyreDiscountBrands = "tyre-discount-brands",
  Users = "users",
  UsersAdmin = "users-admin",
  UsersDMS = "users-dms",
  UsersOneIPlanningMonteur = "users-oneiplanning-monteur",
  UsersPlanItPlanningMechanic = "users-planitplanning-mechanic",
  VehicleTyreReplacements = "vehicle-tyre-replacements",
  Webhooks = "webhooks",
  WebhookCreateSupportTickets = "webhook-create-support-tickets",
  XentryJobs = "xentry-jobs"
}

export interface Role {
  created_on: string;
  updated_on: string;
  id: ROLES;
  name: string;
  acl?: ACL[];
}

export interface ACL {
  created_on: string;
  updated_on: string;
  id: ACLID;
  activity: string;
  resource: string;
  roles?: Role[];
}
